import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, ServiceResult, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface GetCreateReportIncorrectProductInfo extends ApiParameter {
    feedbackEmail: string,
    feedbackMessage: string,
    feedbackfor: string,
    productUrl: string,
    sku: string,
    onSuccess?: () => void;
}
interface GetBaseModel extends BaseModel {
    ReportIncorrectProduct: GetCreateReportIncorrectProductInfo
}

const createURL = "/api/v1/reportIncorrectProductInfo";

export async function getReportIncorrectProductInfo(
    parameter: GetCreateReportIncorrectProductInfo,
): Promise<ServiceResult<GetBaseModel>> {
    try {
        const getCreateReportIncorrectProductInfo = await post<GetBaseModel>(`${createURL}`, {
            feedbackEmail: parameter.feedbackEmail,
            feedbackMessage: parameter.feedbackMessage,
            feedbackfor: parameter.feedbackfor,
            productUrl: parameter.productUrl,
            sku: parameter.sku
        } as any);
        return {
            result: getCreateReportIncorrectProductInfo,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

